export const DOMAINS_SEARCH_SUITE_TRANSLATIONS_NS = 'domains-search-suite-translations-ns';
export const resourceLoader = async locale => {
  return import(`./locale/messages_${locale}.json`);
};
//# sourceMappingURL=resourceLoader.js.map